import { createGlobalStyle } from "styled-components";
import { pxToEm } from "../../util/helpers";
import constants from "./constants";

const GlobalStyle = createGlobalStyle`
  * {
    font-family:  -apple-system, BlinkMacSystemFont, “Segoe UI”, “Roboto”, “Oxygen”, “Ubuntu”, “Cantarell”, “Fira Sans”, “Droid Sans”, “Helvetica Neue”, sans-serif;
    box-sizing: border-box;
    line-height: 1.5;
  }

  body {
    font-size: 100%;
    margin: 0;
    position: relative;
    overflow-x: hidden;

    //background: no-repeat linear-gradient(0deg, rgba(0, 174, 239, 0.00) 0%, rgba(0, 174, 243, 0.12) 100%), #FFF;

    background: no-repeat linear-gradient(
      180deg,
      rgba(0, 174, 243, 0.2) 0,
      rgba(0, 174, 243, 0) 160px,
      rgba(0, 174, 239, 0) 320px
    ),
    #ffffff;
    color: ${constants.TEXT_COLOR_DARK};
    display: flex;
  }

  #root {
    width: 100%;
  }

  a, a:visited {
    font-size: ${pxToEm(14, 16)}rem;
    color: ${constants.LINK_COLOR};
    text-align: center;
    font-weight: bold;
  }

  img {
    max-width: 100%
  }

  .cfl:first-letter {
    text-transform: capitalize;
  }

  .ric-hidden {
    position: absolute!important;
    clip: rect(1px,1px,1px,1px)!important;
    padding: 0!important;
    border: 0!important;
    height: 1px!important;
    width: 1px!important;
    overflow: hidden!important;
  }

  form {
    max-width: 350px;
    margin: auto;
  }
`;

GlobalStyle.defaultProps = {
  bodyColor: constants.MAIN_BODY_COLOR
};

export default GlobalStyle;
